<ngx-spinner [name]="pageLevelSpinner" *ngIf="!componentLoaded" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-spin-fade" [fullScreen]="true">
	<p style="color: white">Loading...</p>
</ngx-spinner>
<app-confirmation-popup />

<div *ngIf="buildIsOutdated" class="overlay"></div>
<div *ngIf="componentLoaded" class="main-container">
	<app-side-navbar
		[groups]="sideNavGroups"
		[loading]="!menuLoaded"
		[collapsed]="false"
		(itemSelected)="onSideNavItemSelected($event)"
		(favoriteToggled)="onSideNavFavoriteToggled($event)"
	></app-side-navbar>
	<app-content-container [sideBarExpanded]="sidebarExpanded" (onTogglerClick)="toggleSideNav()"></app-content-container>
</div>

<dx-popup
	[width]="700"
	[height]="150"
	[showTitle]="true"
	title="Refresh web page"
	[dragEnabled]="false"
	[hideOnOutsideClick]="false"
	[showCloseButton]="false"
	[(visible)]="buildIsOutdated"
	contentTemplate="popup-content"
	[wrapperAttr]="{ id: 'elementId', class: 'invalid-build-popup' }"
>
	<div *dxTemplate="let data of 'popup-content'" style="display: flex; flex-direction: column; justify-content: space-between">
		<p>A new version is available, please refresh your app before continuing.</p>
		<div style="display: flex; justify-content: end">
			<button class="btn-performance-refresh" mat-raised-button (click)="refreshApp()">Refresh</button>
		</div>
	</div>
</dx-popup>
